import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/loader/styles.scss';export default {
  "reportsList": "_reportsList_1fses_1",
  "report": "_report_1fses_1"
};